/**
 * LogTypeService
 * Service for LogType entity operations
 * Route: api/log-type
 */
import { CrudService } from '../base/CrudService';
/**
 * LogTypeService
 * Handles log type CRUD operations
 */
export class LogTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LogTypeService.DEFAULT_SERVICE_PATH,
            basePath: LogTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
LogTypeService.DEFAULT_SERVICE_PATH = 'tasks';
LogTypeService.BASE_PATH = 'api/log-type';
//# sourceMappingURL=LogTypeService.js.map